<template>
  <v-container fluid>
    <!-- 一覧部 -->
    <v-row no-gutters>
      <v-col cols="12">
        <custom-data-table :tableName="tableName" :header="headers" :items="items" :loading="loading" :visibleStore="false">
          <template v-slot:button>
            <v-btn class="mr-2" depressed small color="success" @click.stop="showRefineDialog" :disabled="false">絞込み</v-btn>
          </template>
          <template v-slot:action="{ item }">
            <v-btn v-if="updatePermission" class="mr-2" depressed small color="primary" @click.stop="showEditDialog(item.id)">経費確認</v-btn>
          </template>
        </custom-data-table>
      </v-col>
    </v-row>
    <!-- 絞込みダイアログ -->
    <v-row justify="center">
      <v-dialog v-model="refineDialogDrawer" persistent max-width="500">
        <v-card>
          <v-container>
            <v-card-title class="headline">絞り込み</v-card-title>
            <v-card-text>
              <v-form ref="refine_dialog_form" v-model="refineDialogValid" @submit.prevent>
                <!-- 開始日付、終了日付 -->
                <v-row>
                  <v-col cols="12" md="5">
                    <v-menu min-width="290px" max-width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field v-on="on" label="開始日付" v-model="startFormatted" dense outlined readonly @blur="start_date = parseDate(startFormatted)">
                        </v-text-field>
                      </template>
                      <v-date-picker v-model="start_date" no-title scrollable actions locale="ja-jp" :close-on-content-click="true" :day-format="date => new Date(date).getDate()"/>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" md="5">
                    <v-menu min-width="290px" max-width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field v-on="on" label="終了日付" v-model="endFormatted" dense outlined readonly @blur="end_date = parseDate(endFormatted)">
                        </v-text-field>
                      </template>
                      <v-date-picker v-model="end_date" no-title scrollable actions locale="ja-jp" :close-on-content-click="true" :day-format="date => new Date(date).getDate()"/>
                    </v-menu>
                  </v-col>
                </v-row>
                <!-- 工番 -->
                <v-row>
                  <v-col cols="12" md="10">
                    <v-select label="工番" v-model="construction" :items="construction_list" item-text="name" item-value="value" no-data-text="データがありません" dense outlined return-object>
                    </v-select>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-btn class="mt-1" depressed small color="error" @click.stop="clearRefineField(1)">クリア</v-btn>
                  </v-col>
                </v-row>
                <!-- 部署 -->
                <v-row>
                  <v-col cols="12" md="10">
                    <v-select label="部署" v-model="department" :items="department_list" item-text="name" item-value="value" no-data-text="データがありません" dense outlined return-object>
                    </v-select>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-btn class="mt-1" depressed small color="error" @click.stop="clearRefineField(2)">クリア</v-btn>
                  </v-col>
                </v-row>
                <!-- 監督者 -->
                <v-row>
                  <v-col cols="12" md="10">
                    <v-select label="監督者" v-model="management_user" :items="management_user_list" item-text="name" item-value="value" no-data-text="データがありません" dense outlined return-object>
                    </v-select>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-btn class="mt-1" depressed small color="error" @click.stop="clearRefineField(3)">クリア</v-btn>
                  </v-col>
                </v-row>
                <!-- 作業者 -->
                <v-row>
                  <v-col cols="12" md="10">
                    <v-select label="作業者" v-model="worker_user" :items="worker_user_list" item-text="name" item-value="value" no-data-text="データがありません" dense outlined return-object>
                    </v-select>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-btn class="mt-1" depressed small color="error" @click.stop="clearRefineField(4)">クリア</v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn depressed color="grey lighten-1" @click.stop="hideRefineDialog">キャンセル</v-btn>
              <v-btn depressed color="success" @click.stop="execRefine" :disabled="!refineDialogValid">絞込み</v-btn>
            </v-card-actions>
          </v-container>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- 経費確認ダイアログ -->
    <v-row justify="center">
      <v-dialog v-model="expenseDialogDrawer" persistent max-width="1200">
        <v-card>
          <v-container>
            <v-card-title class="headline">経費確認</v-card-title>
            <v-card-text>
              <v-form ref="expense_input_form" v-model="expenseDialogValid" @submit.prevent>
                <div v-for="(data, name) in expense.expenseDataTable" :key="name">
                  <v-row class="mt-5">
                    <v-col cols="12">
                      <v-data-table :headers="expense.headers" :items="data" :items-per-page="itemPerPage" hide-default-footer :key="renderingKeyCount">
                        <template slot="top">
                          <v-toolbar color="grey" dark flat dense>
                              <v-toolbar-title>{{ name }}</v-toolbar-title>
                              <v-spacer/>
                              <v-btn depressed color="success" @click="createExpenseItem(name)">新規作成</v-btn>
                          </v-toolbar>
                        </template>
                        <template v-slot:[`item.action`]="{ item }">
                          <v-btn class="mr-2" depressed color="primary" @click="editExpenseItem(item)">入力</v-btn>
                          <v-btn class="mr-2" depressed color="error" @click="deleteExpenseItem(item)">削除</v-btn>
                        </template>
                        <template v-slot:no-data>
                          データがありません。
                        </template>
                      </v-data-table>
                      <v-divider></v-divider>
                    </v-col>
                  </v-row>
                </div>
              </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn depressed color="grey lighten-1" @click.stop="expenseDialogDrawer=!expenseDialogDrawer">キャンセル</v-btn>
                <v-btn depressed color="primary" @click.prevent="confirmationDialogDrawer=!confirmationDialogDrawer" :disabled="!expenseDialogValid">確認</v-btn>
            </v-card-actions>
          </v-container>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- 費目入力ダイアログ -->
    <v-row justify="center">
      <v-dialog v-model="expenseInputDialog" persistent max-width="500px">
        <v-card>
          <v-card-title class="headline">費目入力</v-card-title>
          <v-card-text>
            <v-container>
              <v-select v-if="expense.expenseItems.length > 0 && !editFlg" v-model="expense.expenseItem" label="費目選択" :items="expense.expenseItems" item-text="expense" @change="expenseChange" no-data-text="データがありません" dense outlined return-object/>
              <v-divider v-if="expense.expenseItems.length > 0 && !editFlg" class="mb-5"/>
              <v-form ref="expense_input_form" v-model="expenseInputValid" @submit.prevent>
                <v-text-field v-model="expense.expense" :rules="expenseNameRules" label="費目名" dense outlined>
                  <template v-slot:append>
                    <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                  </template>
                </v-text-field>
                <v-text-field v-model="expense.standard" :rules="standardNameRules" label="規格等" dense outlined></v-text-field>
                <v-text-field v-model="expense.achievement" :rules="amountRules" label="数量" dense outlined>
                  <template v-slot:append>
                    <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                  </template>
                </v-text-field>
                <v-text-field v-model="expense.displayUnit" :rules="displayUnitRules" label="単位" dense outlined>
                  <template v-slot:append>
                    <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                  </template>
                </v-text-field>
                <v-row no-gutters>
                  <v-col cols="11">
                    <v-autocomplete label="取引先" v-model="expense.supplier" :items="expense.suppliers" item-text="name" item-value="value" hide-no-data hide-selected outlined dense return-object/>
                  </v-col>
                  <v-col cols="1">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon class="mt-2 ml-3" color="success" @click.stop="supplierStoreDialogHandler" v-on="on">mdi-plus-circle</v-icon>
                      </template>
                      <span>取引先登録</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
                <v-text-field v-model="expense.remarks" label="備考" :rules="remarksRules" dense outlined required></v-text-field>
              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey lighten-1" @click.stop="expenseInputCancelHandler">キャンセル</v-btn>
            <v-btn color="success" @click.stop="expenseInputSaveHandler" :disabled="!expenseInputValid">保存</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- 取引先登録ダイアログ -->
    <v-row justify="center">
      <v-dialog v-model="supplierStoreDialog" persistent max-width="500">
        <v-card>
          <v-card-title class="headline">取引先登録</v-card-title>
          <v-card-text>
            <v-form ref="suppliers_form" v-model="supplierValid" @submit.prevent>
              <v-text-field label="取引先名" v-model="supplierName" :rules="suppliersNameRules" dense outlined>
                <template v-slot:append>
                  <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                </template>
              </v-text-field>
              <v-text-field label="備考" v-model="supplierRemarks" :rules="remarksRules" dense outlined></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn depressed color="grey lighten-1" @click.stop="supplierStoreDialogCancelHandler">キャンセル</v-btn>
            <v-btn depressed color="success" @click.prevent="supplierStore" :disabled="!supplierValid">登録</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- 費目削除ダイアログ -->
    <v-row justify="center">
      <v-dialog v-model="expenseDeleteDialog" persistent max-width="500">
        <v-card>
          <v-card-title class="headline">費目削除</v-card-title>
          <v-card-text>
            <h4>{{ expense.editedItem.expense }} を削除しますか？</h4>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn depressed color="grey lighten-1" @click.stop="expenseDeleteDialog = !expenseDeleteDialog">キャンセル</v-btn>
            <v-btn depressed color="error" @click.stop="expenseDeleteHandler">削除</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- 作業日報確認ダイアログ -->
    <v-row justify="center">
      <v-dialog v-model="confirmationDialogDrawer" persistent max-width="700px">
        <v-card>
          <v-card-title>
            <span class="headline">作業日報確認</span>
          </v-card-title>
          <v-card-text>
            <v-tabs v-model="confirmationSelectTab" background-color="accent" dark next-icon="mdi-arrow-right-bold-box-outline" prev-icon="mdi-arrow-left-bold-box-outline" show-arrows>
              <v-tab v-for="index in 1" :key="index" :href="'#tab-' + index">
                {{ tabDataList['tab-1'].tabName }}
              </v-tab>
              <v-tabs-slider color="red"/>
            </v-tabs>
            <v-tabs-items v-model="confirmationSelectTab">
              <v-tab-item v-for="index in 1" :key="index" :value="'tab-' + index">
                <v-row v-if="tabDataList['tab-' + index].constructionType != null">
                  <v-col cols="4"><header>工種</header></v-col>
                  <v-col cols="8"><header>{{ tabDataList['tab-' + index].constructionType.name }}</header></v-col>
                </v-row>
                <v-divider/>
                <v-row v-if="(tabDataList['tab-' + index].workItem != null)">
                  <v-col cols="4"><header>作業項目</header></v-col>
                  <v-col cols="8"><header>{{ tabDataList['tab-' + index].workItem.name }}</header></v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                  <div v-for="(data, name) in tabDataList['tab-' + index].expenseTableData" :key="name">
                    <v-data-table v-if="data.length > 0" :headers="comformHeaders" :items="data" :items-per-page="itemPerPage" hide-default-footer>
                        <template slot="top">
                          <v-toolbar color="grey" dark flat dense>
                              <v-toolbar-title>{{ name }}</v-toolbar-title>
                          </v-toolbar>
                        </template>
                    </v-data-table>
                    <v-divider v-if="data.length > 0"/>
                  </div>
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey lighten-1" @click="confirmationDialogDrawer=!confirmationDialogDrawer">キャンセル</v-btn>
            <v-btn color="success" @click.stop="execEdit">更新</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- 費目登録時警告ダイアログ -->
    <v-row justify="center">
      <v-dialog v-model="expenseAlertDialog" persistent max-width="500">
        <v-card>
          <v-card-title class="headline">
            <span><v-icon large class="mr-2" color="red">mdi-alert-octagon</v-icon>実行できません</span>
          </v-card-title>
          <v-card-text>
            選択された費目は既に登録されています。
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn depressed color="grey lighten-1" @click.stop="expenseAlertDialog=!expenseAlertDialog">閉じる</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import { useAppInsights } from '@/plugins/application-insights';
import statusList from "@/helpers/const";
import Rule from "@/validation/rules";
import SuppliersApi from "@/api/suppliers-api";
import WorkerDailyReportExpenseBulkApi from "@/api/worker-daily-report-expense-bulk-api";
import CustomDataTable from "@/components/custom_ui/CustomDataTable";

export default {
  name: "WorkerDailyReportExpenseBulk",
  components: {
    CustomDataTable,
  },
  props: ["user"],
  data: () => ({
    // --------------------------------
    // 共通コンポーネント: データテーブル関連
    // --------------------------------
    loading: false,
    tableName: "作業日報(経費)一括修正",
    headers: [
      { text: "日付", value: "worker_date"},
      { text: "工番", value: "construction_number_name"},
      { text: "部署", value: "department_name_section"},
      { text: "監督者", value: "management_user_name"},
      { text: "作業者", value: "worker_user_name"},
      { text: "アクション", value: "action"},
    ],
    items: [],
    // 編集権限
    updatePermission: false,
    // --------------------------------
    // 絞込みダイアログ
    // --------------------------------
    refineDialogDrawer: false,
    refineDialogValid: false,
    // 日付（開始・終了）
    start_date: '',
    startFormatted: '',
    end_date: '',
    endFormatted: '',
    // 工番
    construction: null,
    construction_list: [],
    // 部署
    department: null,
    department_list: [],
    // 監督者
    management_user: null,
    management_user_list: [],
    // 作業者
    worker_user: null,
    worker_user_list: [],
    // 退避用
    stackItems: {
      // 日付（開始・終了）
      start_date: '',
      startFormatted: '',
      end_date: '',
      endFormatted: '',
      // 工番
      construction: null,
      // 部署
      department: null,
      // 監督者
      management_user: null,
      // 作業者
      worker_user: null,
    },
    // --------------------------------
    // 経費確認ダイアログ
    // --------------------------------
    expenseDialogDrawer: false,
    expenseDialogValid: false,
    selectedItemsIndex: 0,

    selectTab: 'tab-1',
    renderingKeyCount: 0,
    expenseDivisionData: [],
    // 本データ用
    tabDataList: {},
    itemPerPage: 300,

    expense: {
      expenseDataTable: null,
      expenseSelectBox: null,
      headers: [
        { text: "費目名", value: "expense" },
        { text: "規格等", value: "standard" },
        { text: "実績 / 予算", value: "displayAchievement" },
        { text: "単位", value: "displayUnit" },
        { text: "取引先", value: "supplierName" },
        { text: "アクション", value: "action" }
      ],
      id: "",
      editedIndex: -1,
      editedItem: {},
      expense: "",
      standard: "",
      amount: "",
      achievement: "",
      displayUnit: "",
      unitPrice: "",
      remarks: "",
      priceUpdated: "",
      before_price: null,
      price_updated: "単価",
      suppliers: [],
      supplier: null,
      expenseItems: [],
      expenseItem: null
    },

    // ------------------------
    // 費目入力ダイアログ
    // ------------------------
    expenseInputDialog: false,
    expenseInputValid: false,
    editFlg: false,
    expenseChangeFlg: false,
    expenseNameRules: Rule.expenseNameRules,
    standardNameRules: Rule.standardNameRules,
    amountRules: Rule.amountRules,
    displayUnitRules: Rule.displayUnitRules,
    unitPriceRules: Rule.unitPriceRules,
    remarksRules: Rule.remarksRules,

    // ------------------------
    // 取引先登録ダイアログ
    // ------------------------
    supplierStoreDialog: false,
    supplierName: "",
    supplierRemarks: "",
    supplierValid: false,
    suppliersNameRules: Rule.suppliersNameRules,

    // ------------------------
    // 費目削除ダイアログ
    // ------------------------
    expenseDeleteDialog: false,

    // ------------------------
    // 作業報告確認ダイアログ
    // ------------------------
    confirmationDialogDrawer: false,
    confirmationSelectTab: null,
    comformHeaders: [
      { text: "費目名", value: "expense" },
      { text: "規格等", value: "standard" },
      { text: "実績 / 予算", value: "displayAchievement" },
      { text: "単位", value: "displayUnit" },
      { text: "取引先", value: "supplierName" }
    ],
    // ------------------------
    // 費目登録時警告ダイアログ
    // ------------------------
      expenseAlertDialog: false,
  }),
  created() {
    this.initialize();
  },
  watch: {
    'start_date': function(){
      if (this.end_date < this.start_date) {
          this.end_date = this.start_date;
      }
      this.startFormatted = this.formatDate(this.start_date);
    },
    'end_date': function(){
      if (this.start_date > this.end_date) {
          this.start_date = this.end_date;
      }
      this.endFormatted = this.formatDate(this.end_date);
    },
  },
  methods: {
    // -----------------------------------------------------
    // ローディングの表示/非表示処理
    // -----------------------------------------------------
    isLoading() {
      this.loading = !this.loading;
      this.$emit("loading", this.loading);
    },
    // -----------------------------------------------------
    // 初期化処理
    // -----------------------------------------------------
    initialize() {
      this.tabDataList['tab-1'] = { tabName : "TEST!!"};
      this.isLoading();
      this.suppliersApi = new SuppliersApi();
      this.workerDailyReportExpenseBulkApi = new WorkerDailyReportExpenseBulkApi();
      // 権限
      if (this.user.role_id == 0) {
        this.updatePermission = this.user.permission_config.CTSG00019.update;
      }
      // 検索条件(必須)：検索開始日・終了日を初期セット（当月１日～当日）
      const now = new Date();
      this.start_date = now.getFullYear() + "-" + ("00" + (now.getMonth() + 1)).slice(-2) + "-" + "01";
      this.end_date = now.getFullYear() + "-" + ("00" + (now.getMonth() + 1)).slice(-2) + "-" + ("00" + (now.getDate())).slice(-2);
      // 検索条件(任意)：他の検索条件項目をセット
      const prm_construction = (this.construction == null) ? "0" : this.construction.value;
      const prm_department = (this.department == null) ? "0" : this.department.value;
      const prm_management_user = (this.management_user == null) ? "0" : this.management_user.value;
      const prm_worker_user = (this.worker_user == null) ? "0" : this.worker_user.value;
      // 一覧データ取得（API送信実行）
      const promise = this.workerDailyReportExpenseBulkApi.list(
        this.start_date,
        this.end_date,
        prm_construction,
        prm_department,
        prm_management_user,
        prm_worker_user
      );
      promise.then(response => {
        // 一覧表示リストを構築
        this.items = response.data.body.worker_daily_report_expense_bulk_list;
        for (let item of this.items) {
          item.construction_number_name = item.construction_number + ' ' + item.construction_name;
          item.department_name_section = item.department_name + ' - ' + item.department_section;
        }
        // 工番リストを構築（絞り込みダイアログ用）
        for (let item of response.data.body.construction_list) {
          this.construction_list.push({
            name: item.construction_number + ' ' + item.name, value: item.id
          });
        }
        // 部署リストを構築（絞り込みダイアログ用）
        for (let item of response.data.body.department_list) {
          this.department_list.push({
            name: item.name + ' - ' + item.section, value: item.id
          });
        }
        // 監督者・作業者リストを構築（絞り込みダイアログ用）
        for (let item of response.data.body.user_list) {
          this.management_user_list.push({
            name: item.name, value: item.id
          });
          this.worker_user_list.push({
            name: item.name, value: item.id
          });
        }
      }).catch(error => {
        useAppInsights().trackException({exception: error});
        if (error.response) {
          if (error.response.data.status == statusList.status.authError) {
            this.$emit('logoutConform');
          } else if (error.response.data.status == statusList.status.entityError) {
            this.$emit("error", error.response.data.message);
            this.$router.push({ name: "Dashboard" });
          } else {
            this.$emit("error", error.response.data.message);
          }
        } else {
          this.$emit("error","サーバーエラーが発生しました。");
        }
      }).finally(() => {
        this.isLoading();
      });
    },
    // -----------------------------------------------------
    // 絞込みボタン押下時（絞込みダイアログを表示する）
    // -----------------------------------------------------
    showRefineDialog() {
      // キャンセル用変数へ退避してダイアログ表示
      this.stackItems.start_date = this.start_date;
      this.stackItems.startFormatted = this.startFormatted;
      this.stackItems.end_date = this.end_date;
      this.stackItems.endFormatted = this.endFormatted;
      this.stackItems.construction = this.construction;
      this.stackItems.department = this.department;
      this.stackItems.management_user = this.management_user;
      this.stackItems.worker_user = this.worker_user;
      this.refineDialogDrawer = true;
    },
    // -----------------------------------------------------
    // 絞込みダイアログ：クリアボタン押下時（入力項目をクリアする）
    // -----------------------------------------------------
    clearRefineField(idx) {
      switch (idx) {
        case 1: // 工番
          this.construction = null;
          break;
        case 2: // 部署
          this.department = null;
          break;
        case 3: // 管理者
          this.management_user = null;
          break;
        case 4: // 作業者
          this.worker_user = null;
          break;
      }
    },
    // -----------------------------------------------------
    // 絞込みダイアログ：キャンセルボタン押下時（絞込みダイアログを非表示する）
    // -----------------------------------------------------
    hideRefineDialog() {
      // キャンセル用変数から復元してダイアログ非表示
      this.start_date = this.stackItems.start_date;
      this.startFormatted = this.stackItems.startFormatted;
      this.end_date = this.stackItems.end_date;
      this.endFormatted = this.stackItems.endFormatted;
      this.construction = this.stackItems.construction;
      this.department = this.stackItems.department;
      this.management_user = this.stackItems.management_user;
      this.worker_user = this.stackItems.worker_user;
      this.refineDialogDrawer = false;
    },
    // -----------------------------------------------------
    // 絞込みダイアログ：絞込みボタン押下時（表示リストを再構築する）
    // -----------------------------------------------------
    execRefine() {
      // ダイアログを非表示
      this.refineDialogDrawer = false;
      const prm_construction = (this.construction == null) ? "0" : this.construction.value;
      const prm_department = (this.department == null) ? "0" : this.department.value;
      const prm_management_user = (this.management_user == null) ? "0" : this.management_user.value;
      const prm_worker_user = (this.worker_user == null) ? "0" : this.worker_user.value;
      // 一覧データ取得（API送信実行）
      const promise = this.workerDailyReportExpenseBulkApi.list(
        this.start_date,
        this.end_date,
        prm_construction,
        prm_department,
        prm_management_user,
        prm_worker_user
      );
      this.isLoading();
      promise.then(response => {
        // 一覧表示リストを構築
        this.items = response.data.body.worker_daily_report_expense_bulk_list;
        for (let item of this.items) {
          item.construction_number_name = item.construction_number + ' ' + item.construction_name;
          item.department_name_section = item.department_name + ' - ' + item.department_section;
        }
        // 工番リストを構築（絞り込みダイアログ用）
        this.construction_list = [];
        for (let item of response.data.body.construction_list) {
          this.construction_list.push({
            name: item.construction_number + ' ' + item.name,
            value: item.id
          });
        }
        // 部署リストを構築（絞り込みダイアログ用）
        this.department_list = [];
        for (let item of response.data.body.department_list) {
          let the_name = item.name;
          if (item.section) {
              the_name += " - " + item.section;
          }
          this.department_list.push({
            name: the_name,
            value: item.id
          });
        }
        // 監督者・作業者リストを構築（絞り込みダイアログ用）
        this.management_user_list = [];
        this.worker_user_list = [];
        for (let item of response.data.body.user_list) {
          this.management_user_list.push({
            name: item.name,
            value: item.id
          });
          this.worker_user_list.push({
            name: item.name,
            value: item.id
          });
        }
      }).catch(error => {
        useAppInsights().trackException({exception: error});
        if (error.response) {
          if (error.response.data.status == statusList.status.authError) {
            this.$emit('logoutConform');
          } else if (error.response.data.status == statusList.status.entityError) {
            this.$emit("error", error.response.data.message);
            this.$router.push({ name: "Dashboard" })
          } else {
            this.$emit("error", error.response.data.message);
          }
        } else {
          this.$emit("error", "サーバーエラーが発生しました。");
        }
      }).finally(() => {
        this.isLoading();
      });
    },
    // -----------------------------------------------------
    // 経費確認ボタン押下時処理（経費確認ダイアログを表示する）
    // -----------------------------------------------------
    showEditDialog(id) {
      // 選択行のデータを決定
      let selitem = null;
      let idx = 0;
      for (let item of this.items) {
        if (item.id === id) {
          this.selectedItemsIndex = idx;
          selitem = item;
          break;
        }
        idx++;
      }
      this.expense.expenseDataTable = null;
      // 対象の作業日報情報を取得する
      if (selitem) {
        this.isLoading();
        const promise = this.workerDailyReportExpenseBulkApi.info(id);
        promise.then((response) => {
          const worker_daily_report_info = response.data.body.worker_daily_report_info;
          const suppliers_list = response.data.body.suppliers_list;
          const aggregate_list = response.data.body.aggregate_list;
          this.tabDataList[this.selectTab] = worker_daily_report_info.report;
          // 取引先情報
          for (let item of suppliers_list) {
            this.expense.suppliers.push({
              name: item.name,
              value: item.id
            });
          }
          // 集計費目情報
          for (let agregateName in aggregate_list) {
            const agregate = response.data.body.aggregate_list[agregateName];
            this.expenseDivisionData[agregateName] = agregate;
          }
          // 経費情報をセット
          if (this.tabDataList[this.selectTab].constructionType != null) {
            const constructionTypeIndex = this.tabDataList[this.selectTab].constructionType.value;
            this.tabDataList[this.selectTab].expenseTableData = this.tabDataList[this.selectTab].expenseTableDataList[constructionTypeIndex];
            for (let data of this.expenseDivisionData) {
              if (!(data.name in this.tabDataList[this.selectTab].expenseTableData)) {
                this.tabDataList[this.selectTab].expenseTableData[data.name] = [];
              }
            }
            this.expense.expenseDataTable = this.tabDataList[this.selectTab].expenseTableData;
            this.tabDataList[this.selectTab].expenseSelectBox = this.tabDataList[this.selectTab].expenseSelectBoxList[constructionTypeIndex];
            this.expense.expenseSelectBox = this.tabDataList[this.selectTab].expenseSelectBox;
          }
        }).catch(error => {
          useAppInsights().trackException({exception: error});
          if (error.response) {
            if (error.response.data.status == statusList.status.authError) {
              this.$emit('logoutConform');
            } else if (error.response.data.status == statusList.status.entityError) {
              this.$emit("error", error.response.data.message);
              this.$router.push({ name: "WorkerDailyReport" })
            } else {
              this.$emit("error", error.response.data.message);
            }
          } else {
            this.$emit("error", "サーバーエラーが発生しました。");
          }
        }).finally(() => {
          this.isLoading();
        });
      }
      // 経費確認ダイアログを表示
      this.expenseDialogDrawer = true;
    },
    // -----------------------------------------------------
    // 経費区分
    // -----------------------------------------------------
    // 「新規登録」ボタン押下時処理
    createExpenseItem(name) {
      if (this.$refs.expense_input_form != null) {
        this.$refs.expense_input_form.resetValidation();
      }
      const aggregate = this.expenseDivisionData.find((item) => { return (item.name === name); });
      const aggregateName = name;
      if ((name in this.expense.expenseSelectBox) && this.expense.expenseSelectBox[name].length > 0) {
        this.expense.expenseItems = this.expense.expenseSelectBox[name];
      } else {
        this.expense.expenseItems = [];
      }
      this.expense.editedItem = {
        id: "",
        supplier: null,
        supplierName: "",
        aggregate: aggregate,
        aggregateName: aggregateName,
        amount: "",
        displayUnit: "",
        expense: "",
        multiple: 0,
        no: 0,
        percentage: 1,
        price: 0,
        standard: "",
        tax: 0.1,
        taxName: "10%",
        unitPrice: 0,
        achievement: 0,
        displayAchievement: "",
        remarks: "",
        priceUpdated: this.getNowYMD()
      };
      this.expense.price_updated = "単価";
      this.editFlg = false;
      this.expenseChangeFlg = false;
      this.expenseInputDialog = true;
    },
    // 「入力」ボタン押下時処理
    editExpenseItem(item) {
      this.expense.editedItem = item;
      this.expense.expense = this.expense.editedItem.expense;
      this.expense.standard = this.expense.editedItem.standard;
      this.expense.amount = this.expense.editedItem.amount;
      this.expense.achievement = this.expense.editedItem.achievement;
      this.expense.displayUnit = this.expense.editedItem.displayUnit;
      this.expense.unitPrice = this.expense.editedItem.unitPrice;
      this.expense.supplier = this.expense.editedItem.supplier;
      this.expense.remarks = this.expense.editedItem.remarks;
      this.expense.before_price = this.expense.editedItem.unitPrice;
      this.expense.priceUpdated = "priceUpdated" in this.expense.editedItem ? this.expense.editedItem.priceUpdated : this.getNowYMD();
      this.expense.price_updated = "単価 (更新日時: " + this.expense.priceUpdated + ")";
      this.editFlg = true;
      this.expenseInputDialog = true;
    },
    // 「削除」ボタン押下時処理
    deleteExpenseItem(item) {
      this.expense.editedItem = item;
      this.expenseDeleteDialog = true;
    },
    // -----------------------------------------------------
    // 費目入力ダイアログ
    // -----------------------------------------------------
    // 「費目」リスト選択値変更処理
    expenseChange() {
      // 費目反映
      if (this.expense.expenseItem.id) {
        this.expense.id = this.expense.expenseItem.id;
      }
      this.expense.expense = this.expense.expenseItem.expense;
      this.expense.standard = this.expense.expenseItem.standard;
      this.expense.amount = this.expense.expenseItem.amount;
      this.expense.achievement = this.expense.expenseItem.amount;
      this.expense.displayUnit = this.expense.expenseItem.displayUnit;
      this.expense.unitPrice = this.expense.expenseItem.unitPrice;
      this.expense.before_price = this.expense.expenseItem.unitPrice;
      this.expense.priceUpdated = "priceUpdated" in this.expense.expenseItem ? this.expense.expenseItem.priceUpdated : this.getNowYMD();
      this.expense.price_updated = "単価 (更新日時: " + this.expense.priceUpdated + ")";
      this.expenseChangeFlg = true;
    },
    // 「保存」ボタン押下時処理
    expenseInputSaveHandler() {
      var checkflg = false;
      this.expense.editedItem.id = this.expense.id;
      this.expense.editedItem.expense = this.expense.expense;
      this.expense.editedItem.standard = this.expense.standard;
      this.expense.editedItem.amount = this.expense.amount;
      this.expense.editedItem.achievement = this.expense.achievement;
      this.expense.editedItem.displayUnit = this.expense.displayUnit;
      this.expense.editedItem.unitPrice = this.expense.unitPrice;
      this.expense.editedItem.price = this.expense.achievement * this.expense.unitPrice;
      this.expense.editedItem.supplier = this.expense.supplier;
      this.expense.editedItem.supplierName = this.expense.supplier ? this.expense.supplier.name : "";
      this.expense.editedItem.displayAchievement = this.expense.amount ? this.expense.achievement + " / " + this.expense.amount : this.expense.achievement + " / -";
      this.expense.editedItem.remarks = this.expense.remarks;
      if (this.expense.priceUpdated) {
        this.expense.editedItem.priceUpdated = this.expense.priceUpdated;
      }
      if(!this.editFlg){
        if(this.expense.editedItem.id == ""){
          this.expense.editedItem.id = new Date().getTime().toString() + Math.floor(Math.random() * 10).toString();
        }
        // for(var expenseitem of this.tabDataList[this.selectTab].expenseTableData[this.expense.editedItem.aggregateName]){
        //   if(expenseitem.id == this.expense.editedItem.id){
        //     checkflg = true;
        //   }
        // }
      }
      if (checkflg) {
        this.expenseAlertDialog = true;
        this.expense.expenseItem = null;
        this.expense.id = "";
        this.expense.expense = "";
        this.expense.standard = "";
        this.expense.amount = "";
        this.expense.achievement = "";
        this.expense.displayUnit = "";
        this.expense.unitPrice = "";
        this.expense.supplier = null;
        this.expense.remarks = "";
        this.expense.before_price = null;
        this.expense.priceUpdated = "";
        this.renderingKeyCount += 1;
        this.createExpenseItem(this.expense.editedItem.aggregateName);
      } else {
        const index = this.tabDataList[this.selectTab].expenseTableData[this.expense.editedItem.aggregateName].indexOf(this.expense.editedItem);
        if(index > -1) {
          this.tabDataList[this.selectTab].expenseTableData[this.expense.editedItem.aggregateName][index] = this.expense.editedItem
        } else {
          this.tabDataList[this.selectTab].expenseTableData[this.expense.editedItem.aggregateName].push(this.expense.editedItem);
        }
        this.expenseInputCancelHandler();
      }
    },
    // 「キャンセル」ボタン押下時処理
    expenseInputCancelHandler() {
      this.expense.expenseItem = null;
      this.expense.id = "";
      this.expense.expense = "";
      this.expense.standard = "";
      this.expense.amount = "";
      this.expense.achievement = "";
      this.expense.displayUnit = "";
      this.expense.unitPrice = "";
      this.expense.supplier = null;
      this.expense.remarks = "";
      this.expense.before_price = null;
      this.expense.priceUpdated = "";
      this.expenseInputDialog = false;
      this.renderingKeyCount += 1;
      this.expenseChangeFlg = false;
    },
    // -----------------------------------------------------
    // 取引先登録ダイアログ
    // -----------------------------------------------------
    // 「取引先登録」ボタン押下時処理
    supplierStoreDialogHandler() {
      this.supplierStoreDialog = true;
      if (this.$refs.suppliers_form) {
        this.$refs.suppliers_form.resetValidation();
      }
    },
    // 「キャンセル」ボタン押下時処理
    supplierStoreDialogCancelHandler() {
      this.supplierStoreDialog = false;
      this.supplierName = "";
      this.supplierRemarks = "";
    },
    // 「登録」ボタン押下時処理
    supplierStore() {
      if (this.$refs.suppliers_form.validate()) {
        this.isLoading();
        const params = {
          name: this.supplierName,
          remarks: this.supplierRemarks,
        };
        const promiseStore = this.suppliersApi.store(params);
        promiseStore.then((response) => {
          this.$emit('success', response.data.message);
        }).catch(error => {
          useAppInsights().trackException({exception: error});
          if (error.response) {
            if (error.response.data.status == statusList.status.authError) {
              this.dialogDrawer = false;
              this.$emit('logoutConform');
            } else {
              this.$emit("error", error.response.data.message);
            }
          } else {
            this.$emit("error", "サーバーエラーが発生しました。");
          }
        }).finally(() => {
          this.supplierStoreDialog = false;
          const promiseList = this.suppliersApi.list();
          promiseList.then((response) => {
            this.expense.suppliers = [];
            for (var sup of response.data.body.suppliers_list) {
              this.expense.suppliers.push({
                name: sup.name,
                value: sup.id
              });
            }
          }).catch(error => {
            useAppInsights().trackException({exception: error});
            if (error.response) {
              if (error.response.data.status == statusList.status.authError) {
                this.$emit('logoutConform');
              } else if (error.response.data.status == statusList.status.entityError) {
                this.$emit("error", error.response.data.message);
                this.$router.push({ name: "Dashboard" })
              } else {
                this.$emit("error", error.response.data.message);
              }
            } else {
              this.$emit("error", "サーバーエラーが発生しました。");
            }
          }).finally(() => {
            this.supplierName = "";
            this.supplierRemarks = "";
            this.isLoading();
          });
        });
      }
    },
    // -----------------------------------------------------
    // 費目削除ダイアログ
    // -----------------------------------------------------
    expenseDeleteHandler() {
      const index =  this.tabDataList[this.selectTab].expenseTableData[this.expense.editedItem.aggregateName].indexOf(this.expense.editedItem);
      this.tabDataList[this.selectTab].expenseTableData[this.expense.editedItem.aggregateName].splice(index, 1)
      this.expenseDeleteDialog = false;
    },
    // -----------------------------------------------------
    // 経費確認ダイアログ：更新ボタン押下時処理（作業日報をDB更新）
    // -----------------------------------------------------
    execEdit() {
      const idx = this.selectedItemsIndex;
      let upditem = this.items[idx];
      this.confirmationDialogDrawer = false;
      this.expenseDialogDrawer = false;
      // DBへ反映（API送信実行）
      const params = {
        report: JSON.stringify(this.tabDataList[this.selectTab])
      };
      const promise = this.workerDailyReportExpenseBulkApi.update(upditem.id, params);
      this.isLoading();
      promise.then(response => {
        this.$emit("success", response.data.message);
      }).catch(error => {
        useAppInsights().trackException({exception: error});
        if (error.response) {
          if (error.response.data.status == statusList.status.authError) {
            this.$emit('logoutConform');
          } else {
            this.$emit("error", error.response.data.message);
          }
        } else {
          this.$emit("error", "サーバーエラーが発生しました。");
        }
      }).finally(() => {
        this.isLoading();
      });
    },
    // -----------------------------------------------------
    // 現在日付取得（yyyy/mm/dd形式）
    // -----------------------------------------------------
    getNowYMD() {
      var dt = new Date();
      var y = dt.getFullYear();
      var m = ("00" + (dt.getMonth()+1)).slice(-2);
      var d = ("00" + dt.getDate()).slice(-2);
      var result = y + "/" + m + "/" + d;
      return result;
    },
    // -----------------------------------------------------
    // 日付フォーマット（ハイフン区切りをスラッシュ区切りyyyy/mm/dd形式の日付に変換）
    // -----------------------------------------------------
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${year}/${month}/${day}`;
    },
    // -----------------------------------------------------
    // 日付フォーマット（スラッシュ区切りをハイフン区切りyyyy-mm-dd形式の日付に変換）
    // -----------------------------------------------------
    parseDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }
  }
};
</script>
